import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [identifier, setIdentifier] = useState("");
  const [token, setToken] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [step, setStep] = useState(1);

  const requestReset = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post("/auth/forgot-password", { identifier });
      if (data.dev_token) setToken(data.dev_token);
      toast.success("Si le compte existe, un lien a été généré.");
      setStep(2);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  const reset = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/reset-password", { token, new_password: newPassword });
      toast.success("Mot de passe mis à jour !");
      setStep(3);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  return (
    <div className="min-h-[80vh] px-4 py-8 max-w-md mx-auto">
      <h1 className="font-[Manrope] font-extrabold text-2xl">Mot de passe oublié</h1>
      {step === 1 && (
        <form onSubmit={requestReset} className="mt-6 space-y-3">
          <Label>Email ou téléphone</Label>
          <Input data-testid="forgot-identifier" required className="h-12 rounded-xl" value={identifier} onChange={(e) => setIdentifier(e.target.value)} />
          <Button data-testid="forgot-submit" className="w-full h-12 rounded-xl bg-[#E65100] hover:bg-[#C44100]">Envoyer le lien</Button>
        </form>
      )}
      {step === 2 && (
        <form onSubmit={reset} className="mt-6 space-y-3">
          <div className="p-3 rounded-xl bg-[#FFF8F3] border border-[#E65100]/30 text-xs">
            Mode dev : copiez le token reçu (affiché dans la console backend ou dans la réponse).
          </div>
          <Label>Token</Label>
          <Input data-testid="reset-token" required className="h-12 rounded-xl" value={token} onChange={(e) => setToken(e.target.value)} />
          <Label>Nouveau mot de passe</Label>
          <Input data-testid="reset-new-password" required type="password" minLength={6} className="h-12 rounded-xl" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} />
          <Button data-testid="reset-submit" className="w-full h-12 rounded-xl bg-[#E65100] hover:bg-[#C44100]">Réinitialiser</Button>
        </form>
      )}
      {step === 3 && (
        <div className="mt-6 text-center">
          <div className="text-[#0A7D3A] font-bold mb-2">Mot de passe changé !</div>
          <Link to="/connexion" className="text-[#E65100] font-semibold">Se connecter</Link>
        </div>
      )}
    </div>
  );
}
